import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import Widget from './Widget'
import { ModalButton } from './ModalButton'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`

const ModalWrapper = styled.div`
  max-width: 540px;
  max-height: 226px;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonWrapper = styled.div`
  width: 176px;
  margin: 20px 30px;
`

const StyledWidget = styled(Widget)`
  width: 100%;
  height: 100%;
  border: 0px;
  display: flex;
  flex-direction: column;
`

const Banner = styled.div`
  background-color: #021f39;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 13px 30px;
  justify-content: space-between;
`

const Heading = styled.h3`
  color: #ffffff;
  font-size: 18px;
`

const IconWrapper = styled.div`
  margin: 0;

  .MuiSvgIcon-root {
    fill: #ffffff;
  }
`

const Text = styled.p`
  color: #3e3f42;
  padding: 30px;
  font-size: 16px;
  border-bottom: 1px solid #eaedf3;
`

const Link = styled.p`
  color: #289c91;
  font-weight: 500;
  cursor: pointer;
  font-size: 16px;
  padding: 30px;
`

const CtaWrapper = styled.div`
  display: flex;
  margin: 0;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
`

type Props = {
  heading: string
  text: string
  onButtonClick?: () => void
  buttonText?: string
  onLinkClick?: () => void
  linkText?: string
  icon: ReactNode
}

const SmBannerModal = ({
  heading,
  text,
  onButtonClick,
  buttonText,
  onLinkClick,
  linkText,
  icon
}: Props) => (
  <Container>
    <ModalWrapper>
      <StyledWidget>
        <Banner>
          <Heading>{heading}</Heading>
          <IconWrapper>{icon}</IconWrapper>
        </Banner>
        <Text>{text}</Text>
        <CtaWrapper>
          {linkText && <Link onClick={onLinkClick}>{linkText}</Link>}
          {buttonText && (
            <ButtonWrapper>
              <ModalButton name={buttonText} onClick={onButtonClick} />
            </ButtonWrapper>
          )}
        </CtaWrapper>
      </StyledWidget>
    </ModalWrapper>
  </Container>
)

export default SmBannerModal
